import React, { useEffect, useState } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import Header from "components/user/Header";
import Footer from "components/user/Footer";
import BeritaPopuler from "components/user/BeritaPopuler";

function StrukturOrganisasi() {
  const [data, setData] = useState([]);

  const defaultImage =
    "https://via.placeholder.com/150x200.png?text=Foto+Default";
  const defaultName = "Nama Belum Diisi";
  const defaultPosition = "Jabatan Belum Diisi";

  const fetchData = async () => {
    try {
      const config = {
        method: "get",
        url: `/api_w/strukturorganisasi`,
        headers: {
          db_name: process.env.REACT_APP_DB_NAME,
        },
      };
      const response = await axios.request(config);
      setData(response.data.data || []);
    } catch (error) {
      toast.error(
        "Error Mengambil Data Struktur Organisasi: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Fungsi filter posisi
  const getByPosition = (pos) =>
    data.find((item) =>
      item.postions?.toLowerCase().includes(pos.toLowerCase())
    ) || {};

  const kepala = getByPosition("kepala madrasah");
  const komite = getByPosition("komite");
  const tataUsaha = getByPosition("tata usaha");
  const wakaKurikulum = getByPosition("waka kurikulum");
  const wakaKesiswaan = getByPosition("waka kesiswaan");
  const wakaSarpras = getByPosition("waka sarpras");
  const wakaHumas = getByPosition("waka humas");
  const uks = getByPosition("UKS");
  const labIPA = getByPosition("Kepala Lab IPA");
  const labTI = getByPosition("Kepala Lab TI");
  const perpustakaan = getByPosition("perpustakaan");
  const walikelas7A = getByPosition("wali kelas VII A");
  const walikelas7B = getByPosition("wali kelas VII B");
  const walikelas7C = getByPosition("wali kelas VII C");
  const walikelas7D = getByPosition("wali kelas VII D");
  const walikelas7E = getByPosition("wali kelas VII E");
  const walikelas7F = getByPosition("wali kelas VII F");
  const walikelas7G = getByPosition("wali kelas VII G");
  const walikelas8A = getByPosition("wali kelas VIII A");
  const walikelas8B = getByPosition("wali kelas VIII B");
  const walikelas8C = getByPosition("wali kelas VIII C");
  const walikelas8D = getByPosition("wali kelas VIII D");
  const walikelas8E = getByPosition("wali kelas VIII E");
  const walikelas8F = getByPosition("wali kelas VIII F");
  const walikelas8G = getByPosition("wali kelas VIII G");
  const walikelas9A = getByPosition("wali kelas IX A");
  const walikelas9B = getByPosition("wali kelas IX B");
  const walikelas9C = getByPosition("wali kelas IX C");
  const walikelas9D = getByPosition("wali kelas IX D");
  const walikelas9E = getByPosition("wali kelas IX E");
  const walikelas9F = getByPosition("wali kelas IX F");
  const walikelas9G = getByPosition("wali kelas IX G");
  const guru = getByPosition("guru");
  const siswa = getByPosition("siswa");

  // Komponen Card
  const Card = ({ item, color, posisi }) => (
    <div className="relative w-48 rounded-lg border border-gray-300 bg-white p-3 text-center shadow-md">
      <img
        src={item?.image_url?.trim() || defaultImage}
        alt={item?.name || defaultName}
        className="mx-auto mb-2 h-36 w-28 rounded-lg object-cover"
      />
      <h3
        className="mb-1 px-1 py-1 text-sm font-bold text-white"
        style={{ backgroundColor: color || "#4CAF50" }}
      >
        {item?.postions?.trim() || posisi || defaultPosition}
      </h3>
      <p className="text-xs font-semibold">
        {item?.name?.trim() || defaultName}
      </p>
    </div>
  );

  return (
    <>
      <Header />
      <div className="row mt-[50px] flex flex-wrap gap-6 p-5 md:mt-[75px]">
        <div className="w-full lg:w-[68%]">
            <h2 className="text-[30px] text-center font-bold">Struktur Organisasi Madrasah Jateng Digital Learning</h2>
          <div className="p-6">
            <div className="flex flex-col items-center gap-6">
              {/* Kepala & Komite */}
              <div className="flex items-center gap-20">
                <Card item={kepala} color="#8BC34A" posisi="KEPALA MADRASAH" />
                <Card item={komite} color="#E53935" posisi="KOMITE" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <Card item={tataUsaha} color="#607D8B" posisi="KAUR TATA USAHA" />

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="flex flex-wrap justify-center gap-6">
                <Card
                  item={wakaKurikulum}
                  color="#8BC34A"
                  posisi="WAKA KURIKULUM"
                />
                <Card
                  item={wakaKesiswaan}
                  color="#FF7043"
                  posisi="WAKA KESISWAAN"
                />
                <Card
                  item={wakaSarpras}
                  color="#FFB300"
                  posisi="WAKA SARPRAS"
                />
                <Card item={wakaHumas} color="#0288D1" posisi="WAKA HUMAS" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="mt-6 flex flex-wrap justify-center gap-6">
                <Card item={perpustakaan} posisi="PERPUSTAKAAN" />
                <Card item={labIPA} posisi="KEPALA LAB IPA" />
                <Card item={labTI} posisi="KEPALA LAB TI" />
                <Card item={uks} posisi="UKS" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="mt-6 flex flex-wrap justify-center gap-6">
                <Card item={walikelas7A} posisi="wali kelas VII A" />
                <Card item={walikelas7B} posisi="wali kelas VII B" />
                <Card item={walikelas7C} posisi="wali kelas VII C" />
                <Card item={walikelas7D} posisi="wali kelas VII D" />
                <Card item={walikelas7E} posisi="wali kelas VII E" />
                <Card item={walikelas7F} posisi="wali kelas VII F" />
                <Card item={walikelas7G} posisi="wali kelas VII G" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="mt-6 flex flex-wrap justify-center gap-6">
                <Card item={walikelas8A} posisi="wali kelas VIII A" />
                <Card item={walikelas8B} posisi="wali kelas VIII B" />
                <Card item={walikelas8C} posisi="wali kelas VIII C" />
                <Card item={walikelas8D} posisi="wali kelas VIII D" />
                <Card item={walikelas8E} posisi="wali kelas VIII E" />
                <Card item={walikelas8F} posisi="wali kelas VIII F" />
                <Card item={walikelas8G} posisi="wali kelas VIII G" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="mt-6 flex flex-wrap justify-center gap-6">
                <Card item={walikelas9A} posisi="wali kelas IX A" />
                <Card item={walikelas9B} posisi="wali kelas IX B" />
                <Card item={walikelas9C} posisi="wali kelas IX C" />
                <Card item={walikelas9D} posisi="wali kelas IX D" />
                <Card item={walikelas9E} posisi="wali kelas IX E" />
                <Card item={walikelas9F} posisi="wali kelas IX F" />
                <Card item={walikelas9G} posisi="wali kelas IX G" />
              </div>

              <div className="h-10 w-1 bg-gray-400"></div>
              <div className="mt-4 flex flex-col items-center gap-2">
                <Card item={guru} posisi="DEWAN GURU" />
                <div className="h-10 w-1 bg-gray-400"></div>
                <Card item={siswa} posisi="SISWA" />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:ml-auto lg:w-[30%]">
          <BeritaPopuler />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StrukturOrganisasi;
